import * as React from "react"

import {GROUPED_BY} from "@constants";
import {SelectSeeker} from "@ui-seeker/core";


const OPTIONS = [
	{label: 'Country', value: GROUPED_BY.COUNTRY},
	{label: 'Retailer', value: GROUPED_BY.RETAILER},
	{label: 'Company', value: GROUPED_BY.COMPANY},
	{label: 'Brand', value: GROUPED_BY.BRAND},
	{label: 'Mono/Multi Brand', value: GROUPED_BY.PAGE_CATEGORY},
	{label: 'Page Product Type', value: GROUPED_BY.PAGE_PRODUCT_TYPE},
	{label: 'Image Type', value: GROUPED_BY.IMAGE_TYPE},
	{label: 'Tag', value: GROUPED_BY.TAG},
]

export default function BannerPercentageGroupedSelect({ value, onChange, excludeOptions=[] }) {
	return <SelectSeeker
		sx={{ minWidth: 150 }}
		options={OPTIONS}
		excludeOptions={excludeOptions}
		label="Grouped By"
		value={value}
		onChange={e => onChange(e.target.value)}
	/>

}